// require app styles
import './sass/main.scss';

// require vendor dependencies
import angular from 'angular';
import 'angular-cookies';
import 'angular-sanitize';
import 'angular-ui-bootstrap';
import 'angular-ui-router';

const app = angular.module('survey', [

    // vendor dependencies
    'ngCookies',
    'ngSanitize',
    'ui.bootstrap',
    'ui.router'

]);

app.directive('ngFocus', function($timeout) {
    return {
        link: function ( scope, element, attrs ) {
            scope.$watch( attrs.ngFocus, function ( val ) {
                if ( angular.isDefined( val ) && val ) {
                    $timeout( function () { element[0].focus(); } );
                }
            }, true);

            element.bind('blur', function () {
                if ( angular.isDefined( attrs.ngFocusLost ) ) {
                    scope.$apply( attrs.ngFocusLost );

                }
            });
        }
    };
});

app.config( [
    '$compileProvider',
    function( $compileProvider )
    {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|blob):/);
    }
]);

// app components
import core from './core';
import components from './components';

core(app);
components(app);



// WEBPACK FOOTER //
// ./app/app.js